module.exports = __webpack_public_path__ + "static/img/2011@2x.7cb6034.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2011@2x.png
// module id = YCEQ
// module chunks = 1